import React, { useEffect, useRef } from 'react';
import styles from '../styles/ShakeEntrypoint.module.scss';
import Caret from './form/Caret';
import ShakeDropdown from './ShakeDropdown';
import { useShake } from '../ShakeProvider';
import { ReactComponent as ShakeIcon } from '../media/shake.svg';

export default function ShakeEntrypoint() {
  const { isDropdownOpen, setDropdownOpen } = useShake();
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!isDropdownOpen) return;

    const handleDocMouseDown = (e) => {
      if (!wrapperRef.current) return;
      if (!wrapperRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleDocMouseDown);
    return () => {
      document.removeEventListener('mousedown', handleDocMouseDown);
    };
  }, [isDropdownOpen, setDropdownOpen]);

  return (
    <div className={styles.wrap} ref={wrapperRef}>
      <button
        type="button"
        className={`${styles.button} shake__btnPrimary`}
        aria-haspopup="menu"
        aria-expanded={isDropdownOpen}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setDropdownOpen((open) => !open);
        }}
      >
        <ShakeIcon width={75} height="auto" />
        <Caret />
      </button>
      <ShakeDropdown />
    </div>
  );
}
